import styled from 'styled-components';
import isOmpPlatform from '../../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const StyledKebabWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const StyledKebabLabel = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  text-transform: ${isOmp ? 'capitalize' : 'uppercase'};
  letter-spacing: 1.35px;
`;

export default {};
